import React, { useMemo } from "react";
import { useAuth } from "../../authentication/useAuth";
import { useCustomTranslation } from "../../../helpers/translateHelpers";
import UserMenuItem from "./UserMenuItem";
import { useNavigate } from "../../../helpers/navigationHelpers";

const UserOtherAccounts: React.FC = (): React.ReactElement => {
  const { user, otherAccounts } = useAuth();
  const { tCommon } = useCustomTranslation();
  const navigate = useNavigate();

  const currentTenantAccounts = useMemo(
    () =>
      otherAccounts.filter(
        (x) => !x.customerUserIsDisabled && x.tenantCode === user?.tenantCode,
      ),
    [otherAccounts, user?.tenantCode],
  );

  const differentTenantAccounts = useMemo(
    () =>
      otherAccounts.filter(
        (x) => !x.customerUserIsDisabled && x.tenantCode !== user?.tenantCode,
      ),
    [otherAccounts, user?.tenantCode],
  );

  const handleResign = async (tenantCode: string, customerId: string) =>
    navigate.goToNewCustomer(tenantCode, customerId);

  return (
    <div>
      <div className="text-primary text-[14px]/[16px] font-bold tracking-[-0.14px] uppercase">
        {tCommon("current_tenant_accounts", { companyName: user?.companyName })}
      </div>
      {currentTenantAccounts.map((account) => (
        <UserMenuItem
          key={`${account.companyId}-${account.customerId}`}
          className={`mt-1.5 ${account.customerId === user?.customerId ? "text-primary" : ""}`}
          label={account.customerName}
          onClick={() =>
            // it is not necessary to call when we currently loged in
            account.customerId !== user?.customerId &&
            handleResign(account.tenantCode, account.customerId)
          }
        />
      ))}
      {differentTenantAccounts.length > 0 && (
        <>
          <hr className="border-gray bg-gray my-4" />
          <div className="text-primary text-[14px]/[16px] font-bold tracking-[-0.14px] uppercase">
            {tCommon("different_tenant_accounts")}
          </div>
          {differentTenantAccounts.map((account) => (
            <UserMenuItem
              key={`${account.companyId}-${account.customerId}`}
              label={account.customerName}
              className="mt-1.5"
              onClick={() =>
                handleResign(account.tenantCode, account.customerId)
              }
              description={account.companyName}
            />
          ))}
        </>
      )}
    </div>
  );
};

export default UserOtherAccounts;
